import { Outlet, useLocation } from "react-router-dom";
import HomeButton from "../core/home_btn";
import { Col, Container, Row } from "react-bootstrap";

export const AuthLayout = () => {
    const location = useLocation();
    const isAuthRoot = location.pathname === "/auth";

    return (
        <div>
            {!isAuthRoot && (
                <Container className="mt-4">
                    <Row className="text-center">
                        <Col xs={12} sm={10} md={6} lg={4} className="mx-auto">
                            <HomeButton name='Go Back' route={'/auth'}/>
                        </Col>
                    </Row>
                </Container>
            )}
            <Outlet />
        </div>
    );
}